module.exports = __webpack_public_path__ + "img/nodeBackgroundGrid.1bbae2ce.svg";